module.exports = __webpack_public_path__ + "static/media/bon.7410d941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/bon.jpg
// module id = 722
// module chunks = 0